// tslint:disable

import {get} from 'lodash';
import * as React from 'react';
import {InputField} from '../../components/fields/input.field';
import {Field, FormLib} from '../../components/libs/form.lib';
import {ResourceLoader} from '../../components/libs/resource-loader';
import {DefaultSave} from '../../components/libs/updaters/default-save';
import {Validators} from '../../components/libs/Validators';
import {LoaderComponent} from '../../components/structurals/loader.component';
import {ToggleBoxComponent} from '../../components/structurals/toggle-box.component';
import {TextAreaField} from "../../components/fields/textarea.field";
import {IriField} from "../../components/fields/iri.field";
import {MediaItemField} from "../../components/fields/media-item.field";
// import ReactGoogleMapLoader from "react-google-maps-loader"
// import ReactGooglePlacesSuggest from "react-google-places-suggest"
import axios from "axios";
import {Environment} from "../../environment/environment";
import {JsonField} from "../../components/fields/json.field";
import {MapsLoader} from "../../components/fields/MapsLoader";
// const jsonp = require('jsonp');


const { compose, withStateHandlers } = require("recompose");
const {
    withScriptjs,
    withGoogleMap,
    GoogleMap,
    Marker,
    InfoWindow
} = require("react-google-maps");

const MapWithAMakredInfoWindow = compose(
    withStateHandlers(() => ({
        isOpen: false,
    }), {
        onToggleOpen: ({ isOpen = true }) => () => ({
            isOpen: !isOpen,
        })
    }),
    withScriptjs,
    withGoogleMap
)((props: any) =>
    <div>
        <GoogleMap
            defaultZoom={15}
            center={ props.center }
        >
            <Marker
                position={ props.center }
                onClick={props.onToggleOpen}
            >
                {props.isOpen && <InfoWindow onCloseClick={props.onToggleOpen}>
                    <div>{props.infoText}</div>
                </InfoWindow>}
            </Marker>
        </GoogleMap>
    </div>
);

// const MY_API_KEY = "AIzaSyAYT42w834bZxnkW9kTSiCaDvObp5KDmYo";

export class DefaultEventPlace extends React.Component<any, any> {

    state = {
        search: "",
        value: "",
        placeData: false,
        lat: false,
        lng: false,
        eventPlace: false
    }

    public fullForm: FormLib;

    handleSelectSuggest = async (geocodedPrediction: any, originalPrediction: any) => {
        //console.log(geocodedPrediction, originalPrediction) // eslint-disable-line

        this.fullForm.fields.googlePlaceId.setValue(geocodedPrediction.place_id);
        this.fullForm.fields.latitude.setValue(geocodedPrediction.geometry.location.lat());
        this.fullForm.fields.longitude.setValue(geocodedPrediction.geometry.location.lng());

        this.fullForm.fields.coordinates.setValue({
            latitude: geocodedPrediction.geometry.location.lat(),
            longitude: geocodedPrediction.geometry.location.lng()
        })

        this.fullForm.fields.title.setValue(originalPrediction.structured_formatting.main_text);

        this.fullForm.fields.postCode.setValue(this.getData(geocodedPrediction.address_components, "postal_code"));
        //this.fullForm.fields.city.setValue(this.getData(geocodedPrediction.address_components, "locality"));

        let address = this.getData(geocodedPrediction.address_components, "street_number") + " " + this.getData(geocodedPrediction.address_components, "route")

        if (this.getData(geocodedPrediction.address_components, "locality")) {
            var fetched = await axios.get(`${Environment.get('api.base')}/city?title=${this.getData(geocodedPrediction.address_components, "locality")}`, {withCredentials: true});

            if (fetched.data && fetched.data['hydra:member'] && fetched.data['hydra:member'][0]) {
                this.fullForm.fields.city.setValue(get(fetched.data['hydra:member'][0], "@id"));
            }
        }

        if (this.getData(geocodedPrediction.address_components, "postal_town")) {
            var fetched = await axios.get(`${Environment.get('api.base')}/city?title=${this.getData(geocodedPrediction.address_components, "postal_town")}`, {withCredentials: true});

            if (fetched.data && fetched.data['hydra:member'] && fetched.data['hydra:member'][0]) {
                this.fullForm.fields.city.setValue(get(fetched.data['hydra:member'][0], "@id"));
            }
        }

        this.setState({lat: geocodedPrediction.geometry.location.lat(), lng: geocodedPrediction.geometry.location.lng()})

        this.fullForm.fields.address.setValue(address);

        let service = new google.maps.places.PlacesService(document.createElement('div'));

        service.getDetails({
            placeId: geocodedPrediction.place_id
        }, (place, status) => this.placeCallback(place, status));

        this.setState({search: "", value: geocodedPrediction.formatted_address, placeData: geocodedPrediction})
    }

    public placeCallback(place: any, status: any) {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
            this.fullForm.fields.website.setValue(place.website);
        }
    }

    private executor: DefaultSave<any> = new DefaultSave<any>(null, this.props);

    public async saveForm(form: FormLib): Promise<any> {
        this.executor.updateForm(form);
        await this.executor.exec();
    }

    handleCountryCreated(country: any, form: FormLib) {
        form.fields.country.setValue(get(country, '@id'));
    }

    private getData(datas: any, type: string) {
        for (var i = 0; i < datas.length; i++) {
            for (var j = 0; j < datas[i].types.length; j++) {
                if (datas[i].types[j] == type) {
                    return datas[i].long_name;
                }
            }
        }
        return false;
    }

    private setMap(formData: FormLib) {
        this.fullForm = formData;
    }

    render() {
        return (
            <ResourceLoader entity="event-place" entityId={this.props.ENTITY_ID} render={(form: FormLib, raw: any) => <div>
                {this.setMap(form)}

                <div id="page-title">
                    <h2>
                        {this.props.IS_CREATE ? 'Create new event place' : 'Edit event place'}
                    </h2>
                    <p>Lorem</p>
                </div>
                <LoaderComponent isLoading$={this.executor.loading$}/>
                <div className="row">
                    <div className="col-md-9">
                        <ToggleBoxComponent title="Even place details" color="green" alwaysOpen={true}>
                            <div className="row">
                                <div className="col-xs-12">
                                    <MapsLoader
                                        onSelectSuggest={(a:any, b:any) => this.handleSelectSuggest(a,b) }
                                    />

                                    <div className="divider"></div>

                                    <InputField
                                        field={form.fields.title}
                                        validators={[
                                            Validators.required('Required')
                                        ]}/>

                                    <InputField
                                        field={form.fields.website}
                                    />

                                    <TextAreaField
                                        field={form.fields.description}
                                    />

                                    <IriField
                                        field={form.fields.city}
                                        defaultAll={true}
                                        itemRender={(item: any) => get(item, 'title')}
                                    />

                                    <InputField
                                        field={form.fields.postCode}
                                        validators={[
                                            Validators.required('Required')
                                        ]}
                                    />
                                    <InputField
                                        field={form.fields.address}
                                        validators={[
                                            Validators.required('Required')
                                        ]}
                                    />

                                    <button className="btn btn-success pull-left" onClick={() => this.saveForm(form)}>Save</button>

                                    <br/>
                                    {(this.state.lat || form.fields.latitude.value) &&
                                        <div className="clear" style={{paddingTop: "5px"}}>
                                            <div className="divider"/>
                                            <MapWithAMakredInfoWindow
                                                // googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyAYT42w834bZxnkW9kTSiCaDvObp5KDmYo&v=3.exp&libraries=geometry,drawing,places"
                                                loadingElement={<div style={{height: `100%`}}/>}
                                                containerElement={<div style={{height: `400px`}}/>}
                                                mapElement={<div style={{height: `100%`}}/>}
                                                center={{lat: this.state.lat ? this.state.lat : form.fields.latitude.value, lng: this.state.lng ? this.state.lng : form.fields.longitude.value}}
                                                infoText="Hello"
                                            />
                                        </div>
                                    }
                                    {/*<MapWithASearchBox/>*/}
                                </div>
                            </div>
                        </ToggleBoxComponent>
                    </div>
                    <div className="col-md-3">
                        <ToggleBoxComponent title="Properties" color="green" alwaysOpen={true}>
                            <MediaItemField
                                field={form.fields.logo}
                            />
                            <div className="divider"></div>

                            <JsonField
                                title={'Coordinates'}
                                schema={{
                                    latitude: (schemaField: Field) => <InputField field={schemaField}/>,
                                    longitude: (schemaField: Field) => <InputField field={schemaField}/>
                                }}
                                field={form.fields.coordinates}
                            />

                            <InputField
                                field={form.fields.googlePlaceId}
                                disabled={true}
                            />
                            <InputField
                                field={form.fields.latitude}
                            />
                            <InputField
                                field={form.fields.longitude}
                            />
                        </ToggleBoxComponent>
                    </div>
                </div>

            </div>}/>
        );
    }


}

export default DefaultEventPlace;



// WEBPACK FOOTER //
// ./src/__templates/details/default.event-place.tsx